import React from "react";
import { Spinner } from "react-bootstrap";
import "./LoadingSpinner.css";

export default class LoadingSpinner extends React.Component {
  render() {
    return (
      <div
        className="loading-spinner-container container-fluid animate
      -pulse"
      >
        {this.props.spinner && <div>
          <Spinner animation="border" />
        </div>}
      </div>
    );
  }
}
